import { PhoneVerifying } from '../verifying/PhoneVerifying'
import { CircularProgress, makeStyles, Paper } from '@material-ui/core'
import { useDispatch } from 'react-redux'
import { signedOut } from 'store/slices/auth-slice'
import { Redirect } from 'react-router-dom'
import { useToken } from '../App'
import { useUserProfile } from '../api'

export function VerifyUser() {
  const { userId } = useToken()

  if (!userId) return null

  return <ConfirmationPanel userId={userId} />
}

function ConfirmationPanel({ userId }: any) {
  const classes = useStyles()
  const dispatch = useDispatch()
  const { userProfile } = useUserProfile(userId)

  if (!userProfile) return <CircularProgress />

  if (userProfile.phoneVerified) return <Redirect to={`/user/${userId}`} />

  return (
    <Paper className={classes.verify}>
      <PhoneVerifying
        userId={userId}
        phoneNumber={userProfile.phoneNumber}
        onCancel={() => dispatch(signedOut())}
      />
    </Paper>
  )
}

const useStyles = makeStyles((theme) => ({
  verify: {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 400,
    padding: theme.spacing(2),
    [theme.breakpoints.down('xs')]: {
      width: `calc(100% - ${theme.spacing(2)}px)`,
      transform: 'none',
      top: 0,
      left: 0,
      margin: theme.spacing(1),
    },
    '&:focus': {
      outline: 'none',
    },
  },
}))
